import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import gsap from "gsap";
import "./Navbar.css";
import logo from "./logona.png";
import toast, { Toaster } from "react-hot-toast";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const barRef = useRef(null);
  const linksRef = useRef(null);
  const rightRef = useRef(null);
  const { lang } = useLanguage();
  const t = getT(lang);
  const walletAddress = "FQN4yCNYgZ2hjJKeUzeYzewvSxNVTUBnosECeqh7pump";

  useEffect(() => {
    const bar = barRef.current;
    const links = linksRef.current;
    const right = rightRef.current;
    if (!bar || !links || !right) return;
    const linkEls = links.querySelectorAll('a');
    gsap.set([bar], { opacity: 0, y: -25 });
    gsap.to(bar, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', delay: 0.5 });
    gsap.set(linkEls, { opacity: 0, x: -15 });
    gsap.to(linkEls, { opacity: 1, x: 0, duration: 0.4, stagger: 0.05, delay: 0.8 });
    gsap.set(right, { opacity: 0, x: 15 });
    gsap.to(right, { opacity: 1, x: 0, duration: 0.4, delay: 0.9 });
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress);
    toast.success(t("nav.copied"), {
      duration: 3000,
      position: "top-center",
      style: {
        background: "#b56a29",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: "8px",
        padding: "10px 16px",
      },
    });
  };

  return (
    <header className="navbar-container">
      <div ref={barRef} className="navbar">
        {/* Logo */}
        <div className="navbar-logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Desktop Links */}
        <nav ref={linksRef} className="navbar-links">
          <a href="#about">{t("nav.about")}</a>
          <a href="#how-to-buy">{t("nav.howToBuy")}</a>
          <a href="#story">{t("nav.story")}</a>
          <a href="#roadmap">{t("nav.roadmap")}</a>
          <a href="#tokenomics">{t("nav.tokenomics")}</a>
        </nav>

        {/* Right Side */}
        <div ref={rightRef} className="navbar-right">
          {/* Desktop Copy Contract */}
          <button className="about-buttonnav desktop-only" onClick={handleCopy}>
            {t("nav.copyContract")}
          </button>

          {/* Hamburger */}
          <div
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.nav
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <a href="#about" onClick={() => setMenuOpen(false)}>
              {t("nav.about")}
            </a>
            <a href="#how-to-buy" onClick={() => setMenuOpen(false)}>
              {t("nav.howToBuy")}
            </a>
            <a href="#story" onClick={() => setMenuOpen(false)}>
              {t("nav.story")}
            </a>
            <a href="#roadmap" onClick={() => setMenuOpen(false)}>
              {t("nav.roadmap")}
            </a>
            <a href="#tokenomics" onClick={() => setMenuOpen(false)}>
              {t("nav.tokenomics")}
            </a>

            {/* Mobile Copy Contract Button */}
            <button className="about-buttonnav mobile-only" onClick={handleCopy}>
              {t("nav.copyContract")}
            </button>
            <button
              type="button"
              className="buy-btn"
              onClick={() => setMenuOpen(false)}
            >
              {t("nav.buyNow")}
            </button>
          </motion.nav>
        )}
      </AnimatePresence>

      <Toaster />
    </header>
  );
}

export default Navbar;
